import {_get } from "@api/services/httpService";

export const URL = 'clubs/payment-tokens';

export const getPaymentToken = (idClub) => {
  return _get(URL + '?club.id=' + idClub)
}